module.exports = __webpack_public_path__ + "static/media/snoopyfewclouds02.31fd3539.jpg";